'use client';
import { useQueries as useQueries$1 } from '@tanstack/react-query';
import { useContext } from 'react';
import { composeQueryKey } from '../lib/composeQueryKey.js';
import { useQueryClient } from '../lib/useQueryClient.js';
import { QraftContext } from '../QraftContext.js';

const useQueries = (qraftOptions, schema, args)=>{
    const [options, queryClientByArg] = args;
    const contextValue = useContext(qraftOptions?.context ?? QraftContext);
    return useQueries$1({
        ...options,
        queries: options.queries.map((queryOptions)=>{
            const optionsWithQueryKey = 'parameters' in queryOptions ? (()=>{
                const queryOptionsCopy = Object.assign({
                    queryKey: composeQueryKey(schema, queryOptions.parameters)
                }, queryOptions);
                delete queryOptionsCopy.parameters;
                return queryOptionsCopy;
            })() : queryOptions;
            return {
                ...optionsWithQueryKey,
                queryFn: optionsWithQueryKey.queryFn ?? function({ queryKey: [, queryParams], signal, meta }) {
                    if (!contextValue?.requestFn) throw new Error(`QraftContext.requestFn not found`);
                    return contextValue.requestFn(schema, {
                        parameters: queryParams,
                        baseUrl: contextValue.baseUrl,
                        signal,
                        meta
                    });
                }
            };
        })
    }, useQueryClient(qraftOptions, queryClientByArg));
};

export { useQueries };
//# sourceMappingURL=useQueries.js.map
